import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
    benp01SelectedUsePoint: '',
  },
  mutations: {
    setIsLoading(state, newValue: boolean) {
      state.isLoading = newValue;
    },
    setBenp01SelectedUsePoint(state, newValue: string) {
      state.benp01SelectedUsePoint = newValue;
    },
  },
  actions: {
    clear(context) {
      context.commit('setBenp01SelectedUsePoint', '');
    },
  },
  modules: {
  },
});
